import { useEffect, useState } from 'react'
import { useCheckAppVersionQuery } from '../queries/clockings'

export const useIsOnline = () => {
  const [navigatorOnline, setNavigatorOnline] = useState(navigator.onLine)
  const checkAppVersionQuery = useCheckAppVersionQuery(60000)

  useEffect(() => {
    const handleOnline = () => setNavigatorOnline(true)
    const handleOffline = () => setNavigatorOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  const serverReachable = checkAppVersionQuery.dataUpdatedAt > 0 && checkAppVersionQuery.isFetched

  const isOnline = navigatorOnline && serverReachable

  return { isOnline }
}
